import {useAdminAccess} from './useAdminAccess';
import {ADMIN_BANNER} from '../layouts/config-layout';

/**
 * Hook qui retourne l'offset causé par la bannière admin
 * À utiliser pour ajuster la position des éléments fixed
 */
export function useAdminBannerOffset() {
  const {isAdminAccessMode} = useAdminAccess();

  return isAdminAccessMode ? ADMIN_BANNER.HEIGHT : 0;
}
